import Vue from 'vue'

let bus = new Vue()

export default bus



// WEBPACK FOOTER //
// ./src/_common/js/bus.js